module.exports = __webpack_public_path__ + "static/adrian-a39f9c9c98a61797a9dcdcaecdda8160.jpg";